import { firestore } from './firebase';

// User API

export const doCreateUser = (userId, username, email) =>
    firestore.collection(`users`).doc(userId).set({
        name:  username,
        email: email,
    });

export const updateUserName = (userId, name) =>
    firestore.collection(`users`).doc(userId).set({
        name: name
    }, { merge: true });

// This large request does not seem to be used.  Todo: what happens if we delete it?
export const onceGetUsers = () =>
    firestore.collection('users').get();

export const getUser = (userId) =>
    firestore.collection('users').doc(userId).get();

// Other Entity APIs ...

export const PUBLIC_GAMES = 'games';
export const PRIVATE_GAMES = 'private-games';

export const createGame = (gameCollection, values) =>
    firestore.collection(gameCollection).add(values);

export const updateGame = (gameCollection, gameId, values) =>
    firestore.collection(gameCollection).doc(gameId).set(values, { merge: true });

export const deleteField = (gameCollection, gameId) =>
    firestore.collection(gameCollection).doc(gameId).update();

export const deleteGame = (gameCollection, gameId) =>
    firestore.collection(gameCollection).doc(gameId).delete();

export const getAllPublicGames = () =>
    firestore.collection("games").get();

export const getAllPrivateGames = () =>
   firestore.collection(PRIVATE_GAMES).get();

export const getGamesCreatedGamesInPeriod = (
   gameCollection,
   start,
   end = new Date(Date.now())
) =>
   firestore.collection(gameCollection)
      .where("created", ">=", start)
      .where("created", "<", end)
      .get()

export const getGameStates = (userId) =>
    firestore.collection("users").doc(userId).collection("gameStates").get();

export const getStats = (gameCollection, gameId) =>
   firestore.collection(gameCollection).doc(gameId).collection("stats").get();

export const getLeaderboard = (gameCollection, gameId) =>
   firestore.collection(gameCollection).doc(gameId).collection("leaderboard").get();

// all gameStats within period of time.
export const getAllRecentStats = (cutoffTimestamp) =>
   firestore.collectionGroup('stats')
       .where('lastUpdated', '>', cutoffTimestamp)
      .orderBy("lastUpdated", "desc")
      .get();

export const markUserDeleting = (userId) =>
   firestore.collection(`users`).doc(userId).set({
      deleting:  true
   }, { merge: true });

export const getReviews = (gameCollection, gameId) =>
   firestore.collection(gameCollection).doc(gameId).collection("reviews").get();

export const getReports = (gameCollection, gameId) =>
   firestore.collection(gameCollection).doc(gameId).collection("reports").get();

// Query Snapshots

export const getPublicGamesByUserId = (userId) =>
    firestore.collection("games").where("authorId", "==", userId).get();

export const getPrivateGamesByUserId = (userId) =>
    firestore.collection("private-games").where("authorId", "==", userId).get();

export const getSampleGames = () =>
    firestore.collection("games").where("isSample", "==", true).get();

export const getRemoteStorage = () =>
   firestore.collection("configuration").doc("remoteStorage").get();

export const getPublicGame = (gameId) =>
    firestore.collection("games").doc(gameId).get();

export const getPrivateGame = (gameId) =>
    firestore.collection("private-games").doc(gameId).get();

export const updateClues = (gameCollection, gameId, values) =>
    firestore.collection(gameCollection).doc(gameId).set(values, { merge: true });



// WEBPACK FOOTER //
// ./src/firebase/db.js